<template>
  <div :class="wrapperClasses">
    <img
      :src="src"
      :alt="alt"
      :class="imageClasses"
      loading="lazy"
    />
  </div>
</template>

<script>
export default {
  name: 'ProfileAvatar',
  props: {
    src: { type: String, required: true },
    alt: { type: String, default: 'Profile photo' },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg', 'xl'].includes(v),
    },
    bordered: { type: Boolean, default: true },
    glow: Boolean,
    glass: Boolean,
  },
  computed: {
    sizeMap() {
      return {
        sm: { wrap: 'w-12 h-12', ring: 'ring-2' },
        md: { wrap: 'w-16 h-16', ring: 'ring-2' },
        lg: { wrap: 'w-28 h-28', ring: 'ring-[3px]' },
        xl: { wrap: 'w-32 h-32 sm:w-40 sm:h-40 lg:w-44 lg:h-44', ring: 'ring-4' },
      }
    },
    wrapperClasses() {
      const s = this.sizeMap[this.size]
      return [
        'relative shrink-0 rounded-full overflow-hidden shadow-glass',
        s.wrap,
        this.glass
          ? 'bg-white/20 dark:bg-white/5 backdrop-blur-sm ring-white/60 dark:ring-white/20'
          : 'bg-surface shadow-card',
        this.bordered && !this.glass && `${s.ring} ring-border`,
        this.bordered && this.glass && s.ring,
        this.bordered && this.glass && 'ring-white/50 dark:ring-white/15',
        this.glow && 'shadow-glow ring-primary/30',
      ]
    },
    imageClasses() {
      return 'w-full h-full object-cover rounded-full'
    },
  },
}
</script>
